var _linearGradient, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCoinut(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    clipRule: "evenodd",
    fillRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 2,
    viewBox: "0 0 560 400",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    gradientUnits: "userSpaceOnUse",
    x1: 18,
    x2: 52,
    y1: 33.97,
    y2: 33.97
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#20479d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#0044bc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00aad1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.69144 0 0 1.68605 99.9934 140.988)"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#4275b2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m88.11 16.88c-4.75 0-8.72 1.61-11.48 4.67s-4.1 7.13-4.1 12.06c0 8.06 4.88 16.73 15.58 16.73 4.532.162 8.89-1.795 11.78-5.29 2.529-3.27 3.87-7.307 3.8-11.44 0-10.17-6.11-16.73-15.58-16.73zm0 28.79c-6.6 0-10.38-4.4-10.38-12.06 0-7.33 4.08-12.06 10.38-12.06s10.38 4.73 10.38 12.06c0 7.66-3.78 12.06-10.38 12.06z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m110.15 17.64h5.18v31.93h-5.18z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m143.86 17.64v23.72l-14.94-23.82h-5.61v32.03h5.18v-23.92l14.95 23.92h5.6v-31.93z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m176.62 17.64v20.09c0 6.9-4.8 7.94-7.64 7.94s-7.3-1-7.3-8v-20h-5.18v21.08c-.071 2.962.984 5.844 2.95 8.06 2.18 2.32 5.43 3.55 9.4 3.55 4.12 0 7.5-1.25 9.77-3.61 2.137-2.335 3.279-5.416 3.18-8.58v-20.53z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m186.69 17.54v4.77h10.48v27.16h5.18v-27.26h10.49v-4.67z",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m68.1 50.34-44.26 19.39c-1.597.696-3.483-.038-4.19-1.63l-19.38-44.27c-.702-1.596.034-3.487 1.63-4.19l44.26-19.37c1.597-.696 3.483.038 4.19 1.63l19.4 44.25c.665 1.603-.07 3.471-1.65 4.19z",
    fill: "#010e38",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m35.32 44.9c-5.118-.016-9.32-4.232-9.32-9.35v-3.14c0-5.124 4.216-9.34 9.34-9.34h13.81c1.562-.032 2.834-1.317 2.85-2.88v-2.49c-.005-1.578-1.302-2.875-2.88-2.88h-15.21c-8.728 0-15.91 7.182-15.91 15.91v6.49c.005 8.726 7.184 15.905 15.91 15.91h15.21c1.574-.016 2.864-1.306 2.88-2.88v-2.49c-.005-1.578-1.302-2.875-2.88-2.88z",
    fill: "url(#a)",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoinut);
export default __webpack_public_path__ + "static/media/coinut.2b5387fc9a23a07b88d604abe9308614.svg";
export { ForwardRef as ReactComponent };